<template>
    <div class="case-box">
        <ChildBanner :childbannerData='childbannerData' ref='childBaner' class="white"></ChildBanner>
        <Marketing :marketingData='marketingData' class="black"></Marketing>
        <Project class="black"></Project>
        <DoBetter :childModle='childModleData' class="frist black"></DoBetter>
        <OurServe :serveData='serveData' :swiperOptions='swiperOptions' :scrollbar='scrollbar' class="white"></OurServe>
        <DoBetter :childModle='childModleDatatwo' class="itemtwo black"></DoBetter>
        <CaseItem class="black"></CaseItem>
        <!-- <Hat :hatData='hatData' class="fristhat"></Hat>
        <CaseItem></CaseItem> -->
        <Hat :hatData='hatDatavido' class="lastthat black"></Hat>
        <ItemVideo class="white"></ItemVideo>
    </div>
</template>
<script>
    import ChildBanner from '@/components/base/childbanner'//引入子页面的banner
    import Marketing from '@/components/main/home/marketing'//引入数字化营销服务
    import Project from '@/components/main/home/project'//引入案例集合
    import DoBetter from '@/components/main/contact/dobetter'//引入图文,
    import OurServe from '@/components/main/home/ourserve'//引入我们的服务
    import Hat from '@/components/main/project/hat'//引入说明布局 
    import CaseItem from '@/components/main/case/caseitem'//引入内容布局
    import ItemVideo from '@/components/main/case/itemVideo'//引入内容布局
    export default {
        name: 'Case',
        data() {
            return {
                childbannerData: {
                    childbanner: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20749.jpg',
                    caption: 'Wonderful case',
                    title: '精彩案例'
                },
                // hatData: {
                //     title: '邮件营销',
                //     caption: 'Brand',
                //     showdown: 'Design',
                //     chinese: '<p>很荣幸, 因为我们有你的关注。同时, 恭喜你, 你可能和一家真正专业的公司有合作的机会。因此, 了解以下的合作原则, 对于彼此的共事质量很重要, 了解我们的行事方法和思想, 能在今后的合作中规避矛盾, 加快效率。 彼此协助, 彼此信任, 方能将美好的蓝图兑现。</p>',
                // },
                hatDatavido: {
                    title: '视频拍摄',
                    caption: 'VIDEO',
                    showdown: 'MARKETING',
                    chinese: '<p>网络视频营销具有互动性、主动传播性、传播速度快、成本低廉、感染力强、形式内容多样等特点，又具有互联网营销的优势。很多的外贸企业纷纷开始重视视频营销推广，布局YouTube等视频渠道。<br>而蓝鲸作为一家海外数字化营销公司，在积累了近十年的行业沉淀之后，将制作出更符合海外企业主以及专业买手口味的企业视频、产品视频。以最快的时间抓取海外买家的眼球，留下客户询盘。</p>',
                },
                marketingData: {//第四屏的数据
                    title: '独立站搭建',
                    caption: 'Website',
                    showdown: 'Building',
                    textData: ['ENCOURAGE POSITIVE FEEDBACK SHARE', 'INNOVATION CULTIVATE INDUSTRY PROFESSIONAL'],
                    chinese: '<p>核心团队来源于外贸圈</p><p>海归写手创作原创性文案</p>',
                    english: '<p>匹配谷歌爬虫规则的独立代码编程</p><p>以询盘为目标的项目组，一对一服务</p><p>全定制外贸独立站营销体系</p>',
                },
                childModleData: {
                    center: '让“潜水”的买家在您的鱼池里游起来，激活老客和开拓新客两不误<br/>使用全球顶级营销工具，效果1.5倍增长<br/>定制化创作优质内容，回信率提高100%<br/>及时推送，精准激活老客户和潜在客户<br/>强大的后台数据分析，营销更智能',
                    title: 'Email',
                    showdown: 'Marketing',
                },
                childModleDatatwo: {
                    center: '最适合B2B跨境出海的2大平台，LinkedIn和Facebook深度运营<br/>运营团队拥有平均5年以上的外贸经验<br/>定期数据总结分析，与企业平均每月4次沟通',
                    title: 'Social',
                    showdown: 'Media',
                    caption: 'Do Better.'
                },
                serveData: {//第三屏的数据
                    caption: 'Successful Case',
                    title: '蓝鲸已经帮助多家优质企业通过专业的邮件营销开发了数千名优质潜客',
                    swiperData: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/email/1.jpg',
                            caption: '卫浴行业',
                            title: '<p>蓝鲸通过邮件营销主题三板斧，首次发送邮8000封，收到18封来自全球潜在客户的询价和进一步咨询。效果立竿见影。</p>'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/email/2.jpg',
                            caption: '阀门行业',
                            title: '<p>我们制作了产品介绍、企业公司介绍、制造质量控制介绍等主题邮件，高效激活了优质潜在客户50+。</p>'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/email/3.jpg',
                            caption: '灯具行业',
                            title: '<p>蓝鲸运营团队借助邮件营销引流， 引导至企业官网，通过优质的产品设计，让潜在客户在网站上留下询盘。</p>'
                        },
                    ]
                },
                swiperOptions: {
                    // autoplay: { //匀速滚动
                    //     delay: 3000, //间隔时间0秒
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false, //触摸后仍然执行
                    // },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        hide: false
                    },
                    mousewheel: true,
                    slidesPerView: 1.5,
                    spaceBetween: 48,
                    grabCursor: true
                    // Some Swiper option/callback...
                },
                scrollbar: '#000000',
            }
        },
        components: {
            ChildBanner,
            Marketing,
            Project,
            DoBetter,
            OurServe,
            Hat,
            CaseItem,
            ItemVideo
        },
        methods: {
            childMethods() {
                this.$refs.childBaner.changeShow()
            }
        }
    }
</script>
<style scoped>
    .marketing-box>>>.english-box p,
    .marketing-box>>>.chinese-box p {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(102, 102, 102, 1);
    }

    .marketing-box>>>.right-box {
        display: none;
    }

    .marketing-box>>>.text-box {
        width: 1061px;
        grid-template-columns: 1061px;
    }

    .case-box>>>.marketing-box {
        padding-top: 118px;
        height: 896px;
    }

    .marketing-box>>>.marquee-text {
        padding-top: 0;
        transform: translateY(-20%);
    }

    /* ===================================================分割线 ==========================================*/
    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.center-box {
        width: 59.4%;
        height: 777px;
        padding-left: 14%;
    }

    .DoBetter>>>.center-box::after {
        width: 575px;
        height: 737px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/8259019d3ef70c373be081e011404779.jpg') no-repeat center center;
        top: 137px;
        right: -530px;
    }

    .DoBetter>>>.animetionLine,
    .case-box>>>.DoBetter::before {
        display: none;
    }

    .DoBetter>>>.center-box::before {
        content: 'college';
        transform: rotate(90deg) translate(22%, -115px);
    }

    .DoBetter>>>.title-caption {
        font-size: 52px;
        font-weight: bold;
        line-height: 59px;
        color: rgba(51, 51, 51, 1);
        position: relative;
        margin-bottom: 44px;
    }

    .DoBetter>>>.showdown {
        font-size: 52px;
    }

    .project-box>>>.backgroundTop {
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/photo-1581291518857-4e27b48ff24e.jpg') no-repeat center;
        background-attachment: fixed;
    }

    .frist>>>.title-caption::before {
        content: '“不一样的”邮件营销';
        display: block;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(36, 136, 248, 1);
    }

    .frist>>>.text-center {
        max-width: 60%;
    }

    .DoBetter>>>.text-ul {
        display: grid;
        width: 578px;
        grid-column-gap: 0%;
        grid-template-columns: 1fr 1fr;
        margin-top: 52px;
        padding-left: 15px;
        position: relative;
        z-index: 6;
    }

    .DoBetter>>>.text-li {
        padding-bottom: 26px;
        font-size: 16px;
        font-weight: bold;
        color: #2488F8;
        list-style-type: disc;
    }

    .DoBetter>>>.text-li>h5 {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
    }

    .case-box .frist {
        display: flex;
        justify-content: flex-end;
        padding: 90px 0 118px 0;
    }

    .frist>>>.center-box::after {
        position: absolute;
        content: '';
        display: block;
        width: 50%;
        height: 698px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/4cf20237703399.57494e855f2ec.jpg') no-repeat center;
        background-size: cover;
        transform: translateY(-50%);
        top: 50%;
        right: 90%;
    }

    .frist>>>.center-box::before {
        position: absolute;
        content: 'college';
        display: block;
        font-size: 150px;
        font-weight: bold;
        color: rgba(240, 240, 240, 1);
        top: 0;
        left: 88%;
        transform: rotate(90deg) translate(22%, -165px);
        text-transform: uppercase;
        transform-origin: left top;
    }

    .ourserve-box {
        margin-top: 0;
        margin-bottom: 0;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20763.jpg') no-repeat center;
        background-attachment: fixed;
    }

    .itemtwo>>>.center-box {
        width: 76.61%;
        height: 814px;
    }

    .itemtwo>>>.center-box::after {
        position: absolute;
        content: '';
        display: block;
        width: 55%;
        height: 478px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/stock-photo-54935020.jpg') no-repeat center center;
        background-size: cover;
        top: -181px;
        right: -20%;
    }

    .case-box .itemtwo {
        padding: 442px 0 208px 0;
    }

    .itemtwo>>>.title-caption::before {
        content: '社交媒体';
        display: block;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(36, 136, 248, 1);
    }

    .itemtwo>>>.center-caption {
        right: 0;
        transform: translateY(-68%);
    }

    .case-box .fristhat {
        margin-top: 0;
        width: 1362px;
        height: 900px;
        margin-bottom: 120px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/6e4ed0b5da626cc14666b3651148e281.jpg') no-repeat center center;
    }

    .fristhat>>>.center-box {
        height: 746px;
        width: 671px;
        top: 50%;
        transform: translate(1109px, -50%);
    }

    .case-box .lastthat {
        margin-top: 0;
        margin-left: 140px;
        margin-bottom: 438px;
        width: 70.52%;
        height: 46.6vw;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/photo-1522204538344-922f76ecc041.jpg') no-repeat center center;
        background-size: cover;
    }

    .lastthat>>>.center-box {
        height: auto;
        width: 92.5%;
        padding: 10% 5%;
        bottom: 0;
        right: 0;
        transform: translate(20%, 60%);
    }

    .lastthat>>>.left-center-box {
        max-width: 1004px;
    }

    @media(max-width: 995px) {
        .case-box .frist {
            padding:0%;
        }
        .case-box>>>.marketing-box .title {
            text-align: center;
        }

        .case-box>>>.marketing-box .caption {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .case-box>>>.marketing-box {
            padding-top: 0px;
            height: 400px;
        }

        .project-box>>>.backgroundTop {
            background-attachment: initial;
        }

        .marketing-box>>>.text-box {
            width: 100%;
            height: 100%;
            grid-template-columns: 1fr;
            background-color: rgba(255, 255, 255, .6);

        }

        .marketing-box>>>.english-box p,
        .marketing-box>>>.chinese-box p {
            font-size: 16px;
            line-height: 200%;
            text-align: center;
        }
        .marketing-box>>>.english-box{
            margin-top: 0;
        }

        .marketing-box>>>.marquee-text {
            display: none;
        }

        .frist>>>.title-caption::before {
            top: 0;
            left: 0;
            transform: translate(-10%, -50%);
            font-size: 24px;
            line-height: 137%;
        }

        .frist>>>.center-box::after {
            display: none;
        }

        .frist>>>.center-box {
            width: 100%;
            height: auto;
            min-height: auto;
            background-size: cover;
            justify-content: center;
            align-items: center;
            padding-left: 0;
            background: #ffffff url();
        }

        .frist>>>.center-box::before {
            top: 0;
            left: 92%;
            display: none;
        }

        .frist>>>.title-caption {
            position: relative;
            color: #000000;
            top: 0;
            left: 0%;
            font-size: 24px;
            line-height: 150%;
            transform: translate(0%, 100%);
        }

        .frist>>>.showdown {
            font-size: 24px;
        }

        .frist>>>.title-caption::before {
            font-size: 24px;
        }

        .frist>>>.text-center {
            width: 100%;
            max-width: 100%;
            padding: 5%;
            font-size: 16px;
            font-weight: 400;
            line-height: 200%;
            color: rgba(112, 112, 112, 1);
            background-color: rgba(255, 255, 255, .8);
            transform: translateY(0%);
            text-align: center;
        }

        .DoBetter>>>.text-ul {
            margin-top: 0;
            width: 100%;
            background-color: rgba(255, 255, 255, .8);
            padding: 5%;
        }

        .DoBetter>>>.text-li {
            padding-bottom: 26px;
            font-size: 16px;
            font-weight: bold;
            color: #2488F8;
            list-style-type: none;
        }

        .DoBetter>>>.text-li>h5 {
            font-size: 16px;
            font-weight: 400;
            color: #666666;
        }

        .ourserve-box {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20763.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }

        .ourserve-box>>>.caption {
            font-size: 24px;
            max-width: 100%;
            text-align: center;
        }

        .ourserve-box>>>.title {
            font-size: 16px;
            max-width: 100%;
            text-align: center;
            margin-top: 0;
        }

        .itemtwo>>>.center-box::after {
            display: none;
        }

        .case-box .itemtwo {
            padding:0;
            padding-bottom: 10%;
        }

        .itemtwo>>>.center-box {
            width: 100%;
            height: auto;
            min-height: auto;
            padding-left: 0;
            background: #ffffff url('');
        }
        .itemtwo>>>.mobile-img{
            display: block;
            background: red url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/stock-photo-54935020.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 40vw;
        }

        .itemtwo>>>.center-caption {
            display: none;
        }

        .itemtwo>>>.text-center {
            width: 100%;
            height: 100%;
            transform: translateY(0%);
        }

        .itemtwo>>>.title-caption {
            position: absolute;
            color: #ffffff;
            top: 15%;
            left: 5%;
            font-size: 24px;
            line-height: 150%;
            transform: translateY(0%);
            color: #000000;
        }

        .itemtwo>>>.showdown {
            font-size: 24px;
            line-height: 150%;
            color: transparent;
            -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
            text-stroke: 1px rgba(112, 112, 112, 1);
            font-family: gilroybold4;
        }

        .itemtwo>>>.title-caption::before {
            content: '社交媒体';
            display: block;
            text-transform: uppercase;
            position: absolute;
            top: 0;
            left: 0;
            white-space: nowrap;
            color: rgba(36, 136, 248, 1);
            transform: translateY(-150%);
            font-size: 24px;
            font-weight: bold;
            line-height: 100%;
            color: rgba(36, 136, 248, 1);
        }

        .case-box .lastthat {
            margin-top: 0;
            margin-left: 0;
            margin-bottom: 10%;
            width: 100%;
            height: auto;
        }

        .lastthat>>>.center-box {
            position: relative;
            background-color: rgba(255, 255, 255, 1);
            height: auto;
            width: 100%;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .lastthat>>>.title,.lastthat>>>.caption,.lastthat>>>.showdown{
            font-size: 24px;
        }
        .lastthat>>>.caption{
            margin: 0 0 5% 0;
        }

        /* .case-box .lastthat {
            margin-top: 0;
            margin-left: 0;
            margin-bottom: 1038px;
            width: 100%;
            height: 826px;
        } */

    }

    /* @media(max-width: 1023px) {

        .case-box .lastthat {
            margin-top: 0;
            margin-left: 0;
            margin-bottom: 1038px;
            width: 100%;
            height: 826px;
        }

        .lastthat>>>.center-box {
            background-color: rgba(255, 255, 255, .98);
            height: 1200px;
            width: 90%;
            transform: translate(-50%, 0);
        }

        .lastthat>>>.left-center-box {
            max-width: 1004px;
        }

        .lastthat>>>.chinese-box p {
            font-size: 50px;
            line-height: 150%;
        }

        .lastthat>>>.caption {
            font-size: 75px;
            line-height: 100%;
        }

        .lastthat>>>.showdown {
            font-size: 75px;
        }

        .lastthat>>>.title {
            font-size: 40px;
            line-height: 137.5%;
        }

        .lastthat>>>.left-center-box {
            max-width: 80%;
        }

        .ourserve-box {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20763.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }
    }

    @media(max-width: 416px) {
        .case-box>>>.marketing-box {
            height: 2096px;
        }

        .frist>>>.center-box {
            height: 1600px;
        }
        .case-box .itemtwo {
            padding: 442px 0 1008px 0;
        }
        .case-box .lastthat {
            margin-bottom: 1300px;
        }
        .lastthat>>>.center-box {
            height: 1500px;
        }
    }
    @media(max-width: 375px){
        .frist>>>.center-box {
            height: 1700px;
        }
    }
    @media(max-width: 320px){
        .frist>>>.center-box {
            height: 2000px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/case.vue